export default __webpack_public_path__ + "static/media/Rewards content1.ba4e8e0f.jpg";